import { module } from 'modujs';
import { lazyLoadImage } from '../utils/image';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
          click: {
              close: 'menuClose',
              openSecondary: 'openSecondPanel',
              closeSecondary: 'closeSecondPanel'
          }
        };

        this.secondaryPanel = null;

        this.fadeIn = this.el.animate([
          { background: "rgba(255,255,255,0)" },
          { background: "rgba(255,255,255,0.8)" },
        ], {
          duration: 200,
          fill: "forwards",
          easing: "ease-in-out",
        });

        this.fadeIn.pause();

        this.slideIn = this.$('menu')[0].animate([
          { transform: "translate(-100%,0)" },
          { transform: "translate(0%,0)" },
        ], {
          duration: 200,
          fill: "forwards",
          easing: "ease-in-out",
        });

        this.slideIn.pause();
    }

    init() {
      const allAnchors = this.el.querySelectorAll("a");
      allAnchors.forEach((el) => {
        el.addEventListener("click", this.menuClose.bind(this))
      })
    }

    loadImages() {
      let lazyImages = this.el.querySelectorAll('[data-lazyload]');
      lazyImages.forEach((el) => {
        lazyLoadImage(el, null, () => {
          //callback
        })
      })
    }

    menuOpen() {
      this.call('cartClose', null, 'Headerfloat');
      document.body.style.overflow = "hidden"
      this.el.style.display = "block"
      this.fadeIn.playbackRate = 1;
      this.slideIn.playbackRate = 1;
      this.fadeIn.play();
      this.slideIn.play();

      this.fadeIn.finished.then(() => {
        this.fadeIn.pause();
        this.loadImages();
      });

      this.slideIn.finished.then(() => {
        this.slideIn.pause();
      });
      
    }

    menuClose() {

      this.fadeIn.reverse();
      this.slideIn.reverse();

      this.fadeIn.finished.then(() => {
        document.body.style.overflow = "auto"
        this.el.style.display = "none"

        if(this.secondaryPanel) {
          this.closeSecondPanel();
        }

        this.fadeIn.pause();
      })

      this.slideIn.finished.then(() => {
        this.slideIn.pause();
      });
    }

    openTopPanel(e) {
      this.$(`panel-top`)[0].style.display = "block";
    }

    closeTopPanel(e) {
      this.$(`panel-top`)[0].style.display = "none";
    }

    closeSecondPanel(e) {
      this.openTopPanel();
      this.secondaryPanel.style.display = "none";
      this.secondaryPanel = null;
    }

    openSecondPanel(e) {
      this.closeTopPanel();
      const id = this.getData('id', e.currentTarget);
      this.secondaryPanel = this.$(`panel-${id}`)[0];
      this.secondaryPanel.style.display = "block";
    }
}
